import { render, staticRenderFns } from "./QuirofanoDetalleCirugia.vue?vue&type=template&id=5a9fead9&"
import script from "./QuirofanoDetalleCirugia.vue?vue&type=script&lang=js&"
export * from "./QuirofanoDetalleCirugia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports